export const BUCKET_OBJECTS_TOGGLE_SELECTION =
    'BUCKET_OBJECTS_TOGGLE_SELECTION';
export function actionToggleSelection({ id }) {
    return {
        type: BUCKET_OBJECTS_TOGGLE_SELECTION,
        data: { id },
    };
}

export const BUCKET_OBJECTS_TOGGLE_SELECTION_ALL =
    'BUCKET_OBJECTS_TOGGLE_SELECTION_ALL';
export function actionToggleSelectionAll() {
    return {
        type: BUCKET_OBJECTS_TOGGLE_SELECTION_ALL,
    };
}
